import { Action } from '@ngrx/store';
import { Kiosk } from '../kiosk/kiosk.model';

export enum KioskApiActionTypes {
  LoadKiosksApi = '[Kiosk API] Load Kiosks',
  LoadKiosksSuccessApi = '[Kiosk API] Load Kiosks Success',
  LoadKiosksFailureApi = '[Kiosk API] Load Kiosks Failure',
  LoadKioskApi = '[Kiosk API] Load Kiosk',
  LoadKioskSuccessApi = '[Kiosk API] Load Kiosk Success',
  LoadKioskFailureApi = '[Kiosk API] Load Kiosk Failure',
  CreateKioskApi = '[Kiosk API] Create Kiosk',
  CreateKioskSuccessApi = '[Kiosk API] Create Kiosk Success',
  CreateKioskFailureApi = '[Kiosk API] Create Kiosk Failure',
  UpdateKioskApi = '[Kiosk API] Update Kiosk',
  UpdateKioskSuccessApi = '[Kiosk API] Update Kiosk Success',
  UpdateKioskFailureApi = '[Kiosk API] Update Kiosk Failure',
  DeleteKioskApi = '[Kiosk API] Delete Kiosk',
  DeleteKioskSuccessApi = '[Kiosk API] Delete Kiosk Success',
  DeleteKioskFailureApi = '[Kiosk API] Delete Kiosk Failure',
}

export class LoadKiosksApi implements Action {
  readonly type = KioskApiActionTypes.LoadKiosksApi;
  constructor(public payload: { params: any } = { params: {} }) {}
}

export class LoadKiosksSuccessApi implements Action {
  readonly type = KioskApiActionTypes.LoadKiosksSuccessApi;
  constructor(public payload: { kiosks: Kiosk[] }) {}
}

export class LoadKiosksFailureApi implements Action {
  readonly type = KioskApiActionTypes.LoadKiosksFailureApi;
  constructor(public payload: { message: string }) {}
}

export class LoadKioskApi implements Action {
  readonly type = KioskApiActionTypes.LoadKioskApi;
  constructor(public payload: { id: string }) {}
}

export class LoadKioskSuccessApi implements Action {
  readonly type = KioskApiActionTypes.LoadKioskSuccessApi;
  constructor(public payload: { kiosk: Kiosk }) {}
}

export class LoadKioskFailureApi implements Action {
  readonly type = KioskApiActionTypes.LoadKioskFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class CreateKioskApi implements Action {
  readonly type = KioskApiActionTypes.CreateKioskApi;
  constructor(public payload: { kiosk: Kiosk }) {}
}

export class CreateKioskSuccessApi implements Action {
  readonly type = KioskApiActionTypes.CreateKioskSuccessApi;
  constructor(public payload: { kiosk: Kiosk }) {}
}

export class CreateKioskFailureApi implements Action {
  readonly type = KioskApiActionTypes.CreateKioskFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class UpdateKioskApi implements Action {
  readonly type = KioskApiActionTypes.UpdateKioskApi;
  constructor(public payload: { kiosk: Kiosk }) {}
}

export class UpdateKioskSuccessApi implements Action {
  readonly type = KioskApiActionTypes.UpdateKioskSuccessApi;
  constructor(public payload: { kiosk: Kiosk }) {}
}

export class UpdateKioskFailureApi implements Action {
  readonly type = KioskApiActionTypes.UpdateKioskFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class DeleteKioskApi implements Action {
  readonly type = KioskApiActionTypes.DeleteKioskApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteKioskSuccessApi implements Action {
  readonly type = KioskApiActionTypes.DeleteKioskSuccessApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteKioskFailureApi implements Action {
  readonly type = KioskApiActionTypes.DeleteKioskFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export type KioskApiActions =
  | LoadKiosksApi
  | LoadKiosksSuccessApi
  | LoadKiosksFailureApi
  | LoadKioskApi
  | LoadKioskSuccessApi
  | LoadKioskFailureApi
  | CreateKioskApi
  | CreateKioskSuccessApi
  | CreateKioskFailureApi
  | UpdateKioskApi
  | UpdateKioskSuccessApi
  | UpdateKioskFailureApi
  | DeleteKioskApi
  | DeleteKioskSuccessApi
  | DeleteKioskFailureApi;
